import {
    TitleBoxWrap,
    BoxHeader,
    BoxTitle,
    BorderLine
} from '../../pages/home/homeElements'
import Grid from '@material-ui/core/Grid';
import moment from 'moment'
import {
    MostviewBoxWrap,
    MostviewList,
    MostviewItem,
    MostviewImageLink,
    MostviewImage,
    MostviewBody,
    MostviewNumber,
    MostviewContent,
    MostviewCategory,
    MostviewTitle,
    MostviewDesc,
    MostviewDate
} from './mostViewBoxElements'
import { useEffect, useState } from 'react';
import newsApi from '../../api/newsApi'


const MostViewBox = ({category}) => {
    const [news, setNews] = useState({})
    const [loading, setLoading] = useState(true)
    const [innerWidth, setInnerWidth] = useState(window.innerWidth)

    useEffect(() => {
        window.addEventListener('resize', () => setInnerWidth(window.innerWidth))
    }, [])

    useEffect(() => {
        (async () => {
            const response = await newsApi.getMostViewNews({category})
            setNews(response.news)
            setLoading(false)
        })()
    },[category])



    if(loading) return <></>

    return (
        <MostviewBoxWrap>
                    <BorderLine />
                    <TitleBoxWrap>
                        <BoxHeader>
                            <BoxTitle  to='/'>Xem nhiều</BoxTitle>
                        </BoxHeader>
                    </TitleBoxWrap>
                    <MostviewList>
                        <Grid container spacing={innerWidth < 768 ? 0:2} >
                            {news.map((news, index) => (
                                <Grid key={news._id} item sm={12} md>
                                    <MostviewItem>
                                        <MostviewImageLink title={news.title} to={`/news/${news._id}`}>
                                            <MostviewImage src={news.image} alt={news.title} />
                                        </MostviewImageLink>
                                        <MostviewTitle className='hide-on-pc' title={news.title} to={`/news/${news._id}`}>{news.title}</MostviewTitle>
                                        <MostviewBody className='hide-on-mobile-tablet'>
                                            <MostviewNumber>{index + 1}</MostviewNumber>
                                            <MostviewContent>
                                                <MostviewCategory title={news.category} to='/'>{news.category}</MostviewCategory>
                                                <MostviewTitle title={news.title} to={`/news/${news._id}`}>{news.title}</MostviewTitle>
                                                <MostviewDesc>{news.description}</MostviewDesc>
                                                <MostviewDate>{moment(news.createdAt).fromNow()}</MostviewDate>
                                            </MostviewContent>
                                        </MostviewBody>
                                    </MostviewItem>
                                </Grid>
                            ))}
                        </Grid>
                    </MostviewList>
                </MostviewBoxWrap>
    )
}

export default MostViewBox
